var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datetime"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }